export enum SearchItemType {
    ProgramItem = 'programs',
    Speaker = 'performers',
}

export type EventSearchResponse = {
    type: SearchItemType
    items: Record<string, any>
}[]
